module.exports = "pegasus/assets/theme5/arrow.png";